'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'balloons';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e2e4';
var svgPathData = ['M48 160c0 38.7 22.9 79.7 52.7 115.1 14.2 16.9 28.5 30.8 39.3 40.4 6.4 5.8 13.1 11.3 20 16.5 6.9-5.2 13.5-10.7 20-16.5 10.8-9.7 25.1-23.6 39.3-40.4 29.8-35.4 52.7-76.3 52.7-115.1 0-61.9-50.1-112-112-112S48 98.1 48 160zm32 0c0-44.2 35.8-80 80-80l0 48c-17.7 0-32 14.3-32 32l-48 0zM324.8 293.5c8.8 15.8 19.8 31.1 31.9 45.6 14.2 16.9 28.5 30.8 39.3 40.4 6.4 5.8 13.1 11.3 20 16.5 6.9-5.2 13.5-10.7 20-16.5 10.8-9.7 25.1-23.6 39.3-40.4 29.8-35.4 52.7-76.3 52.7-115.1 0-61.9-50.1-112-112-112-18.4 0-35.7 4.4-51.1 12.3 2 11.6 3.1 23.5 3.1 35.7 0 51.2-20 97.1-43.2 133.5z', 'M219.3 275.1c-14.2 16.9-28.5 30.8-39.3 40.4-6.4 5.8-13.1 11.3-20 16.5-6.9-5.2-13.5-10.7-20-16.5-10.8-9.7-25.1-23.6-39.3-40.4-29.8-35.4-52.7-76.3-52.7-115.1 0-61.9 50.1-112 112-112S272 98.1 272 160c0 38.7-22.9 79.7-52.7 115.1zM0 160C0 272 128 368 128 368l-32 80 128 0-32-80s128-96 128-208C320 71.6 248.4 0 160 0S0 71.6 0 160zM384 432l-32 80 128 0-32-80s128-96 128-208c0-88.4-71.6-160-160-160-23.1 0-45.1 4.9-64.9 13.7 6.3 14.7 11 30.3 13.9 46.6 15.3-7.9 32.7-12.3 51.1-12.3 61.9 0 112 50.1 112 112 0 38.7-22.9 79.7-52.7 115.1-14.2 16.9-28.5 30.8-39.3 40.4-6.4 5.8-13.1 11.3-20 16.5-6.9-5.2-13.5-10.7-20-16.5-10.8-9.7-25.1-23.6-39.3-40.4-12.2-14.4-23.2-29.8-31.9-45.6-8.3 13-18.4 27.1-30.7 41.8 37.7 57.5 90 96.7 90 96.7zM160 128l0-48c-44.2 0-80 35.8-80 80l48 0c0-17.7 14.3-32 32-32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBalloons = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;